import { useAppSelector } from '../app/hooks';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fetchVisibilityConfig } from '../store/user/userV2/actions';
import { VIEW_CONFIGS } from './constants/commonConstants';
import { useSearchParams } from 'react-router-dom';

export const useVisibilityConfig = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const visibilityConfig = useAppSelector((state) => state.user.visibilityConfig)?.additionalDetailsConfig;
    const userData = useAppSelector((state) => state.user.userData);

    useEffect(() => {
        if (!visibilityConfig && userData?.accountType && userData?.primaryEmail && userData?.investorOrgId) {
            const payload = {
                accountType: searchParams.get('accountType') || userData.accountType,
                primaryEmail: userData.primaryEmail,
                investorOrgId: userData.investorOrgId,
                userRole: userData?.roles?.[0] || '',
                configName: VIEW_CONFIGS.AICA_VISIBILITY,
            };

            dispatch(fetchVisibilityConfig(payload));
        }
    }, [dispatch, visibilityConfig, userData?.accountType, userData?.primaryEmail, userData?.investorOrgId, userData?.roles]);

    const refreshConfig = () => {
        if (userData?.accountType && userData?.primaryEmail && userData?.investorOrgId) {
            const payload = {
                accountType: userData.accountType,
                primaryEmail: userData.primaryEmail,
                investorOrgId: userData.investorOrgId,
                userRole: userData?.roles?.[0] || '',
                configName: VIEW_CONFIGS.AICA_VISIBILITY,
            };

            dispatch(fetchVisibilityConfig(payload));
        }
    };

    const isVisible = (configKey: string): boolean => {
        if (!visibilityConfig) return true;

        const value = visibilityConfig[configKey];

        return value === true;
    };

    return {
        config: visibilityConfig,
        isVisible,
        refreshConfig,
    };
};
